import { LOGO_URL } from "@/lib/aps";

export function Logo({ size = 40, showText = true, light = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Your Varsity Application"
        style={{ width: size, height: size }}
        className="rounded-md object-contain"
      />
      {showText && (
        <div className="leading-tight">
          <div
            className={`font-display font-bold text-[15px] tracking-tight ${light ? "text-white" : "text-[#0B2447]"}`}
          >
            Your Varsity
          </div>
          <div className={`font-display text-[11px] uppercase tracking-[0.25em] ${light ? "text-[#F5C32C]" : "text-[#F5C32C]"}`}>
            Application
          </div>
        </div>
      )}
    </div>
  );
}
